<!--
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-18 16:45:16
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-05-20 09:49:12
 * @FilePath: /miaobi-app-h5/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts"></script>

<template>
  <router-view />
</template>

<style>
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
